// Third party imports
import { createSlice } from "@reduxjs/toolkit";

// Initial state
const initialState = {
  subServiceItems: {}, // Changed to object: { [subServiceTypeId]: [...items] }
};

// Slice
const subServiceItemsSlice = createSlice({
  name: "subServiceItems",
  initialState,
  reducers: {
    setSubServiceItems: (state, action) => {
      const { subServiceTypeId, items } = action.payload;
      state.subServiceItems[subServiceTypeId] = items;
    },
    clearSubServiceItems: (state) => {
      state.subServiceItems = {};
    },
    clearSubServiceItemsByType: (state, action) => {
      const subServiceTypeId = action.payload;
      delete state.subServiceItems[subServiceTypeId];
    },
  },
});

// Actions
export const { setSubServiceItems, clearSubServiceItems, clearSubServiceItemsByType } = subServiceItemsSlice.actions;

// Reducer
export default subServiceItemsSlice.reducer;
